'use strict';

export default class VideoSection {
  constructor($selector, selfInit = true) {
    this.$body = $('.video-section__body', $selector);
    this.$media = $('.video-section__media', $selector);

    if(selfInit) this.init($selector);
  }

  init() {
    this.setMinHeight();
    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        this.setMinHeight();
      }, 300);
    });
  }

  setMinHeight() {
    if ($(window).width() >= 1024) {
      //Set minimum height to ensure picture element will not overflow from content height
      const imgHeight = this.$media.outerHeight();
      this.$body.css("min-height", `${imgHeight}px`);
    }
  }
}
